import React, { useEffect, useState } from 'react';
import CurrentAssignmentsHeader from '../../components/CurrentAssignmentsHeader';
import CurrentAssignmentsList from '../../components/CurrentAssignmentsList';
import { DashboardProvider } from '../../../dashboard/context';
import { useAssignmentContext } from '../../context';
import { useIsAssignmentsExistMutation , useSetFilterCollapseMutation } from '../../../../features/authentication/assignApiSlice';
import AssignmentSearchContent from '../../components/AssignmentSearchContent';
import AssignmentCreateContent from '../../components/AssignmentCreateContent';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { DataProvider } from '../../DataContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown,faChevronUp, faFileMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import { useGetFiltersMutation } from '../../../../features/authentication/authApiSlice';
import { useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';

const Layout = () => {
  const {
    isAssignmentsAvailable,
    setIsAssignmentsAvailable,
    filters,
    setFilters,
    importPublicAssignmentCompleted,
    setImportPublicAssignmentCompleted
  } = useAssignmentContext();
  const [checkAssignmentAvailable] = useIsAssignmentsExistMutation();
  const [setFilterCollapse] = useSetFilterCollapseMutation();
  const [selectedCourseName, setSelectedCourseName] = useState('');
  const [isFiltersCollapsed, setIsFiltersCollapsed] = useState(false);
  const location = useLocation();
  const [key, setKey] = useState(location?.state?.keyProp ?? 'search');
  const [getFilters] = useGetFiltersMutation();

  useEffect(() => {
    isAssignmentExist();
    if(!filters && !importPublicAssignmentCompleted)
      getFiltersAsync();
  }, []);

  useEffect(() => {
    if (importPublicAssignmentCompleted) {
      getFiltersAsync();
    }
  }, [importPublicAssignmentCompleted]);

  const isAssignmentExist = async () => {
    const response = await checkAssignmentAvailable().unwrap();
    setIsAssignmentsAvailable(response);
  };

  const setCollapseState = async (isCollapsed) => {
    const options ={
      isCollapsed:isCollapsed
    };
    await setFilterCollapse(options).unwrap();
  };

  const [assignmentBtnState] = useState({
    btns: [
      {
        id: 'tab-search',
        name: 'My Assignments',
        key: 'search'
      },
      {
        id: 'tab-create',
        name: 'Create New',
        key: 'create'
      },
      {
        id: 'tab-browse',
        name: 'Browse Content',
        key: 'browse'
      }
    ]
  });

  const getFiltersAsync = async () => {
    try {
      const persistFilters = await getFilters().unwrap();
      if(persistFilters !== null && persistFilters !== undefined)
      {
        setFilters(persistFilters);
        setIsFiltersCollapsed(persistFilters.isCollapsed);
      }
    } catch (error) {
      console.log(error);
    }
    finally {
      setImportPublicAssignmentCompleted(false);
    }
  };
  return (
    <>
      <DataProvider>
        {isAssignmentsAvailable && (
          <>
            <div className='tabbed-content'>
              <Tabs
                activeKey={key}
                onSelect={(k) => setKey(k)}>
                {assignmentBtnState.btns.map((item, index) => {
                  return (                
                    <Tab
                      eventKey={item.key}
                      key={item.id + index}
                      id={item.id}
                      title={<div className={'tab-title'} >
                        {item.name}</div>}>
                      {item.id == 'tab-search' && <div className={`p-4 ${isFiltersCollapsed ? 'd-none':''}`}
                        id="search-content">
                        <AssignmentSearchContent
                          setSelectedCourseName={setSelectedCourseName}
                          filters={filters}
                        />
                      </div>}
                      {item.id == 'tab-create' && <div className={`p-4 ${isFiltersCollapsed ? 'd-none':''}`}
                        id="create-content">
                        <AssignmentCreateContent showBrowseContent={false} showTitle={true} selectedCourseName={selectedCourseName} fromAssignments={true}/>
                      </div>}
                      {item.id == 'tab-browse' && <div className={`p-4 ${isFiltersCollapsed ? 'd-none':''}`}
                        id="browse-content">
                        <NavLink
                          to={'/questionsSearch'}
                          className="select-questions border-0 h-100 p-4 d-flex flex-column align-items-center justify-content-center text-center text-decoration-none">
                          <span className="mb-3 d-flex align-items-center justify-content-center nav-link-browse-content">
                            <FontAwesomeIcon color="#82A9E2" icon={faFileMagnifyingGlass} />
                          </span>
                          <h4>Browse Content</h4>
                          <p className="mb-0">Select the questions first, then create a new assignment.</p>
                        </NavLink>
                      </div>}
                    </Tab>                  
                  );
                })}</Tabs>
            </div>
            <div className='align-collapsible-btn'>
              <button
                onClick={() => {setCollapseState(!isFiltersCollapsed); setIsFiltersCollapsed(!isFiltersCollapsed);}}
                className="rounded-circle z-index10 collapsible-btn">
                <FontAwesomeIcon icon={isFiltersCollapsed ? faChevronDown : faChevronUp} />
              </button>
            </div>
          </>
        )}
        <CurrentAssignmentsHeader />
        {isAssignmentsAvailable && (
          <CurrentAssignmentsList 
            initialFilters={filters}/>
        )}
      </DataProvider>
    </>
  );
};

const Assignment = () => {
  return (
    <DashboardProvider>
      <Layout />
    </DashboardProvider>
  );
};

export default Assignment;
